const ASSUMED_MAINTENANCE_RATE_PERCENT = 2.5;
const SAFETY_FACTOR = 0.9;
function liquidationMovePercent(leverage) {
    if (!Number.isFinite(leverage) || leverage < 1)
        return null;
    const initialMarginPercent = 100 / leverage;
    const maintenancePercent = Math.min(ASSUMED_MAINTENANCE_RATE_PERCENT, initialMarginPercent / 2);
    return initialMarginPercent - maintenancePercent;
}
export function maxStopLossPercentForLeverage(leverage) {
    const liqMove = liquidationMovePercent(leverage);
    if (liqMove == null)
        return null;
    return Math.floor(liqMove * SAFETY_FACTOR * 10) / 10;
}
export function estimatedLiquidationPrice(entryPrice, leverage, positionType) {
    const liqMove = liquidationMovePercent(leverage);
    if (liqMove == null || !(entryPrice > 0))
        return null;
    return positionType === "LONG"
        ? entryPrice * (1 - liqMove / 100)
        : entryPrice * (1 + liqMove / 100);
}
export function tpSlTriggerPrice(entryPrice, percent, positionType, variant) {
    if (!(entryPrice > 0) || !(percent > 0))
        return null;
    const up = (positionType === "LONG") === (variant === "tp");
    return entryPrice * (up ? 1 + percent / 100 : 1 - percent / 100);
}
export function stopLossPastLiquidationError(stopLossPercent, leverage) {
    if (stopLossPercent == null || !(stopLossPercent > 0) || leverage == null) {
        return null;
    }
    const max = maxStopLossPercentForLeverage(leverage);
    if (max == null || stopLossPercent <= max)
        return null;
    return `Stop loss ${stopLossPercent}% is past the liquidation price at ${leverage}x, so it would never trigger. Use ${max}% or less, or lower the leverage.`;
}
//# sourceMappingURL=stop-loss-limit.js.map